<template>
    <div>
      <router-view></router-view>
      <footer class="footer">
        <div class="footer-item">
          <router-link to="/baocan" class="link">
            <img class="icon" src="@/assets/jilu.png" alt="Logo" />
            <span class="di">报餐</span>
          </router-link>
        </div>
        <div class="footer-item">
          <router-link to="/saoma" class="link">
            <img class="icon" src="@/assets/shenpi.png" alt="Logo" />
            <span class="di">扫码</span>
          </router-link>
        </div>
        <div class="footer-item">
          <router-link to="/wode" class="link">
            <img class="icon" src="@/assets/yuyue.png" alt="Logo" />
            <span class="di">我的</span>
          </router-link>
        </div>
      </footer>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        code: '',
        state: '',
        isAdmin: false, // 用户存储用户是否管理员
      };
    },
  
    mounted() {
      this.handleRedirect();
    },
    methods: {

  
      handleRedirect() {
        this.code = this.$route.query.code;
        this.state = this.$route.query.state;
        console.log(this.code);
  
        if (this.code && this.state) {
          console.log('Code:', this.code);
          console.log('State:', this.state);
  
          // 可以在这里发送这些参数到后端
          axios.post('https://baocan.xiao-e.tech/api/redirect', { code: this.code, state: this.state })
            .then(response => {
              console.log('Response:', response.data);
              console.log('response.data.data:', response.data.data);
              //将response.data.data存入cookie中，后续调用其他api要将这个authorization放在头部发送给前端
              const token = response.data.data;
              // 将 token 存储在LocalStorage 中（或者 Vuex store 中）
              localStorage.setItem('token', token);
              const token1 = localStorage.getItem('token');
              console.log('token1', token1);
              this.getUserRole();
            })
            .catch(error => {
              console.error('Error:', error);
            });
        } else {
          console.error('Missing code or state parameter');
        }
      },
  
      changeSidebar(path) {
        // Check if the current path is different from the target path
        if (this.$route.path !== path) {
          this.$router.push(path); // Navigate to the new route
        }
      },
    }
  };
  </script>
  
  <style scoped>
  .footer {
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #ffffff;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 60px; /* 底部导航栏的高度 */
    border-top: 1px solid #e0e0e0;
    box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1); /* 阴影效果 */
    z-index: 1000; /* 确保在内容之上 */
  }
  
  .footer-item {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .di {
    font-size: 13px;
    font-weight: bold;
  }
  
  .link {
    text-decoration: none; /* 移除链接下的横线 */
    color: #666; /* 默认文字颜色 */
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .link.router-link-exact-active,
  .link:hover {
    color: #007bff; /* 激活状态或悬停时的文字颜色 */
  }
  
  .icon {
    width: 18px; /* Logo大小 */
    height: 18px;
    margin-bottom: 2px; /* Logo与文字之间的间距 */
  }
  
  .iconfont {
    font-size: 24px;
    margin-bottom: 5px;
  }
  
  p {
    margin: 0;
  }
  </style>